module.exports = __webpack_public_path__ + "static/media/documents_enrollment.47680ef6.png";